// extracted by mini-css-extract-plugin
var _1 = "definitionEntry";
var _2 = "definitionEntry__key";
var _3 = "definitionEntry__value";
export { _1 as "definitionEntry", _2 as "definitionEntry__key", _3 as "definitionEntry__value" }
